import React from 'react';

import { DashboardPageLayoutComponent } from 'design/dashboardPageLayout';
import { DashboardContentFallbackLayoutComponent } from 'design/dashboardContentFallbackLayout';
import { TextComponent } from 'design/text/textComponents';
import { useIntlDictionary } from 'hooks/useIntlDictionary';

import { usePartnerClientsPageCancelledData } from 'hooks/usePartnerClientsPageCancelledData';
import {
  PartnerClientsTableItem,
  PartnerClientsTableSortableField,
} from 'types/partnerClientsTable';
import { PartnerCancelledClientsTable } from 'containers/PartnerClientsTable';
import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useAppState } from 'hooks/useAppState';
import { PartnerClientManager } from './PartnerClientManager/PartnerClientManager';

export const PartnerCancelledClientsPage = () => {
  const { partnerClientsPageCancelled: ownDictionary } = useIntlDictionary();

  const { partnerClientManager } = useAppState();

  const [fieldToSortTableBy, setFieldToSortTableBy] = React.useState<
    PartnerClientsTableSortableField
  >('id');

  const dispatch = useAppDispatcher();

  const manageClient = React.useCallback(
    (item: PartnerClientsTableItem) => {
      dispatch({
        name: 'PartnerClientsPage__ManageClient',
        clientId: item.id,
        organizationName: item.organization,
      });
    },
    [dispatch]
  );

  const {
    partnerCancelledClientsTableItems,
    partnerCancelledClientsCount,
    partnerCancelledLicensesCount,
  } = usePartnerClientsPageCancelledData({ fieldToSortTableBy });

  return (
    <>
      <DashboardPageLayoutComponent
        content={
          partnerCancelledClientsTableItems.length > 0 ? (
            <PartnerCancelledClientsTable
              sortedBy={fieldToSortTableBy}
              ascendingSort
              activeItemId={partnerClientManager.clientId}
              items={partnerCancelledClientsTableItems}
              onItemClick={manageClient}
              onSortChange={setFieldToSortTableBy}
            />
          ) : (
            <DashboardContentFallbackLayoutComponent
              title={
                <TextComponent size="mp">
                  {ownDictionary.fallbackTitle}
                </TextComponent>
              }
              description={
                <TextComponent>
                  {ownDictionary.fallbackDescription}
                </TextComponent>
              }
              action={null}
            />
          )
        }
        primaryStat={
          partnerCancelledClientsTableItems.length > 0 && (
            <TextComponent size="mp">
              {ownDictionary.clientsStatText(
                partnerCancelledClientsCount,
                partnerCancelledLicensesCount
              )}
            </TextComponent>
          )
        }
        secondaryStat={null}
        description={
          partnerCancelledClientsTableItems.length > 0 && (
            <TextComponent>{ownDictionary.standardDescription}</TextComponent>
          )
        }
      />
      <PartnerClientManager />
    </>
  );
};
